import { useEffect } from "react"
import { AppConfig } from "./app-config"

const defaultSuffix = ` · ${AppConfig.app_name}`

type Options = { bare?: boolean }

export const useDocumentTitle = (title: string | null, { bare = false }: Options = {}) => {
  useEffect(() => {
    if (title != null) {
      document.title = bare ? title : `${title}${defaultSuffix}`
    }
  }, [title, bare])
}
